import { render } from "./ListAllLessons.vue?vue&type=template&id=24fd3e04&scoped=true"
import script from "./ListAllLessons.vue?vue&type=script&lang=js"
export * from "./ListAllLessons.vue?vue&type=script&lang=js"

import "./ListAllLessons.vue?vue&type=style&index=0&id=24fd3e04&lang=scss&scoped=true"

import exportComponent from "D:\\programmazione\\pronails\\MemsionPrivato\\front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24fd3e04"]])

export default __exports__